import React, { useState, useEffect } from "react";
import { Popover, Button, TextField, Box } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Column, ColumnFiltersState } from "@tanstack/react-table";
import { CustomColumnDef } from "./UsersTypeTable";
import { Axios } from "api/axios";
import { fetchPackages } from "slices/package/thunk";
import { toast } from "react-toastify";

interface UsersTypeFilterPopover<TData> {
  column: Column<TData, unknown>;
  columnDef: CustomColumnDef<TData>;
  columnFilters?: ColumnFiltersState;
  setColumnFilters?: React.Dispatch<React.SetStateAction<ColumnFiltersState>>;
  setColValue?: any;
  iconColor?: string;
}

const UsersTypeFilterPopover = ({
  column,
  columnDef,
  columnFilters,
  setColumnFilters,
  setColValue,
  iconColor,
}: UsersTypeFilterPopover<any>) => {
  const filterType = columnDef.filterType;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [tempValue, setTempValue] = useState(column?.getFilterValue() || "");
  const [name, setName] = useState<string>("name");

  const [options, setOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<Element>) => {
    setAnchorEl(e.currentTarget as HTMLElement);
  };

  const handleClose = () => {
    // setAnchorEl(null);

    // column.setFilterValue(undefined); // or `null` also works

    // if (setColValue) {
    //   setColValue((prev: any) =>
    //     (prev || []).filter(
    //       (f: { filterField: string }) => f.filterField !== column.id
    //     )
    //   );
    // }

    // setTempValue("");
    setAnchorEl(null);
  };

  const handleApply = () => {
  column.setFilterValue(tempValue || undefined);

  if (setColValue) {
    setColValue((prev: any) => {
      const updated = (prev || []).filter(
        (f: { filterField: string }) => f.filterField !== column.id
      );
      return [
        ...updated,
        { filterField: column.id, filterValue: tempValue }
      ];
    });
  }

  setAnchorEl(null);
};


  const handleClear = () => {
    // Clear the filter from the table column
    column.setFilterValue(undefined);

    // Remove it from your local filter state
    if (setColValue) {
      setColValue((prev: any) =>
        (prev || []).filter(
          (f: { filterField: string }) => f.filterField !== column.id
        )
      );
    }

    // Clear the input value
    setTempValue("");
  };

  useEffect(() => {
    const appliedFilter = column.getFilterValue();
  }, []);
  useEffect(() => {
    if (open && columnDef.filterFetchUrl) {
      const fetchOptions = async () => {
        setLoading(true);
        try {
          const response = await Axios.get(columnDef.filterFetchUrl || "");

          const data: any = response.data;
          console.log("data in drodpwn: ", data);
          setOptions(data[column.id]);
        } catch (error) {
          toast.error("Failed to fetch filter options");
          console.error("Failed to fetch filter options:", error);
        } finally {
          setLoading(false);
        }
      };

      fetchOptions();
      if (open) {
        const appliedFilter = column.getFilterValue();
        setTempValue(appliedFilter || "");
      }
    }
  }, [open, columnDef.filterFetchUrl]);

  return (
    <>
      <FilterAltIcon
        fontSize="small"
        onClick={handleOpen}
        style={{ cursor: "pointer", marginLeft: 6, color: iconColor}}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} width={200}>
          {filterType === "dropdown" ? (
            <Autocomplete
  sx={{ width: "100%", textTransform: "capitalize" }}
  size="small"
  id="filter-autocomplete"
  options={options || []}
  // if options are objects, map properly
  getOptionLabel={(option: any) =>
    typeof option === "string" ? option : option?.name || ""
  }
  isOptionEqualToValue={(option: any, value: any) =>
    option?.id === value?.id
  }
  value={
    options?.find((opt: any) =>
      typeof opt === "string"
        ? opt === tempValue
        : opt.name === tempValue
    ) ?? null
  }
  onChange={(_, newValue) => {
    // store only the string (or ID that matches your row value)
    setTempValue(newValue ? (newValue.name ?? newValue) : "");
  }}
  renderInput={(params) => (
    <TextField {...params} variant="outlined" label="Select" />
  )}
/>

          ) : (
            <TextField
              fullWidth
              label="Search"
              value={tempValue}
              onChange={(e) => setTempValue(e.target.value)}
              size="small"
            />
          )}

          <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
            <Button size="small" variant="outlined" onClick={handleClear}>
              Cancel
            </Button>
            <Button size="small" variant="contained" onClick={handleApply}>
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default UsersTypeFilterPopover;
